<div *ngIf="privilegesView==='AccessDenied'||id==='lock'||id===''" class=" outside-container  mt-4" >
  <div class="box-container">
    <div class="container">
      <div  class="  d-flex justify-content-center" >

  <img src="../../../assets/images/AccessDeniedError.png" alt="">
</div>

 </div>
</div>
</div>
<div *ngIf="privilegesView==='VAMD'&&id!='lock'&&id!=''" class="outside-container mt-4">
    <div class="box-container ">
        <div class="container">
            <div class="title ">

              <div class="row">
                <div class=" col-md-2  " ><div class="pointer d-flex justify-content-start "  (click)="backClick()" style="padding-left:20px;">⬅️</div></div>  
               <div class="col-md-7 d-flex justify-content-center">Payment Configuration</div>
               <div class=" col-md-3 row ">
                 <div class="d-flex justify-content-end">
                  <button *ngIf="showCredit" class="btn btn-outline-primary btn-sm " (click)="onAddCredit()"><img src="assets/images/Add_24.png"></button>
                 
               </div>
                </div>
              </div>
            
            </div> 
            </div>
            </div>
          </div>
          <div *ngIf="privilegesView==='VAMD'&&id!='lock'&&id!=''" class="outside-container ">
            <div class="box-container ">
                <div class="container ">
                  <div class="col-md-12 row d-flex justify-content-center " style="padding-left: 20px; ">
                 
                 
                    <div class="col-md-2  "  style="background-color: #d2e1f5; border-radius: 4px; content: right; padding-top: 10px; height:70vh;overflow-y: auto; ">
                      <div class="col-md-12 ">
                        <span class=" d-flex justify-content-center mb-4 mb-2" style=" height: 22px"> <span class=" btns"  (click)="onClickPMedium()"     [ngClass]="{'activity' :showMedium}">Payment Medium</span></span>
                        <span *ngIf="id" class=" d-flex justify-content-center mb-4 mb-2" style=" height: 22px"> <span class=" btns"  (click)="onClickshowPDeposit()"     [ngClass]="{'activity' :showDeposit}">User Balance</span></span>

                      <span *ngIf="type==='lockType'" class=" d-flex justify-content-center mb-4 mb-2" style=" height: 22px"> <span class=" btns"  (click)="onClickCredit()"     [ngClass]="{'activity' :showCredit}">Credit Card</span></span>
                     

                    </div>
                      
                    </div>

                   <div class="col-md-10" style="height:70vh; overflow-y: auto;">
                     <div *ngIf="showCredit" class="col-md-12 card" style="min-height: 100%;" >

                      <div class=" row mt-3 " style="padding: 10px;">
                       
                        
                        <div class="col-md-12 " >
                         
                          
                          <table mat-table
                          [dataSource]="CreditData" multiTemplateDataRows style="background-color: transparent;">
                         
                         
                           <ng-container matColumnDef="enabled">
                             <th mat-header-cell *matHeaderCellDef>Enabled</th>
                             <td mat-cell *matCellDef="let element" > 
                              <mat-icon *ngIf="element.status==='A'" class='font-16-green-icon'>check_circle</mat-icon>
                              <mat-icon *ngIf="element.status==='I'" class='font-16-red-icon'>cancel</mat-icon>
                              </td>
                           </ng-container>
                         
                         
                           <ng-container matColumnDef="bankName" >
                            <th mat-header-cell *matHeaderCellDef>Bank Name</th>
                            <td mat-cell *matCellDef="let element" style="padding: 4px; cursor: pointer; color: rgb(24,118,209);" (click)="rowGroupClick(element)"> {{element?.bankName}} </td>
                           </ng-container>
                         
                           <ng-container matColumnDef="cardNumber" >
                            <th mat-header-cell *matHeaderCellDef>Card Number</th>
                            <td mat-cell *matCellDef="let element"> {{element?.maskedCardNumber }} </td>
                           </ng-container>
                           <ng-container matColumnDef="expiryDate" >
                            <th mat-header-cell *matHeaderCellDef>Expiry Date</th>
                            <td mat-cell *matCellDef="let element"> {{element?.expiryDate}} </td>
                           </ng-container>

                          
                           
                           <ng-container matColumnDef="accountTag" >
                            <th mat-header-cell *matHeaderCellDef>Accounts TAG</th>
                            <td mat-cell *matCellDef="let element"> {{element?.accountsTag||'-'}} </td>
                           </ng-container>
                           <ng-container matColumnDef="priority" >
                            <th mat-header-cell *matHeaderCellDef>Priority</th>
                            <td mat-cell *matCellDef="let element"> {{element?.priority||'-'}} </td>
                           </ng-container>
                           <ng-container matColumnDef="cardType" >
                            <th mat-header-cell *matHeaderCellDef>Card Type</th>
                            <td mat-cell *matCellDef="let element"> {{element?.cardType||'-'}} </td>
                           </ng-container>
                           
                          <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                          <ng-container matColumnDef="expandedDetail">
                          <td mat-cell *matCellDef="let element" [attr.colspan]="columnsCreditDisplay.length">
                          <div class="example-element-detail row"
                           [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                          
                          </div>
                          </td>
                          </ng-container>
                          
                          <tr mat-header-row *matHeaderRowDef="columnsCreditDisplay"></tr>
                          <tr mat-row *matRowDef="let element; columns: columnsCreditDisplay;"
                          class="example-element-row">
                          </tr>
                          <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
                          <tr class="mat-row" *matNoDataRow>
                          <td  class="mat-cell" colspan="4">There is no data in this table</td>
                          </tr>
                          </table>
                          
                          
                          </div>
                          
                      
                    
                    </div> 
                      </div>
                      <div *ngIf="showMedium" class="col-md-12 card" style="min-height: 100%;" >

                      <app-payment-medium></app-payment-medium>
                      </div>
                      <div *ngIf="showDeposit" class="col-md-12 card" style="min-height: 100%;" >

                        <app-payment-deposits></app-payment-deposits>
                        </div>
                    </div>
                    </div>
                </div>

                <div class="modal " id="myMod"  [style.display]="showCreditCardPopup ? 'block' : 'none'" >
                  <div class="modal-dialog" >
                      <div class="modal-content " >
                          <div class="modal-header title">
                            <h4 class="modal-title">Add Credit Card</h4>
                            <button type="button" class="close" data-dismiss="modal" (click)="closePopup()">&times;</button>
                            </div>
                            <div class="modal-body">
                            <div class="col-md-12 mt-3 " *ngIf="showCreditCardPopup">
                              <div class="col-md-12 d-flex justify-content-center" >
                              <div class="col-md-12 row " >
                                  <div class=" col-md-12 ">
                                    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
                                      <mat-tab  label="Details">
                                        <form [formGroup]="creditRegFg"  (ngSubmit)="AddCreditCard()" autocomplete="off"  class="pt-3 row" >
                                          <mat-form-field class="col-md-3" appearance="outline" >
                                            <mat-label>Priority</mat-label>
                                            <mat-select matNativeControl name="priority" formControlName="priority" >
                                              <mat-option *ngFor="let number of numbers" [value]="number.toString()">{{ number }}</mat-option>
  
                                            </mat-select>  
                                            <small *ngIf="creditRegFg.controls['priority'].dirty && creditRegFg.controls['priority'].invalid" class="warn">Please Select Priority!</small>
  
                                          </mat-form-field>
                                          <mat-form-field class="col-md-3" appearance="outline">
                                            <mat-label>Product</mat-label>
                                            <mat-select matNativeControl name="product" formControlName="product">
                                              <mat-option *ngFor="let product of productdata"  [value]="product">{{product}}</mat-option>
                                            </mat-select>  
                                            <small *ngIf="creditRegFg.controls['product'].dirty && creditRegFg.controls['product'].invalid" class="warn">Please Select Product!</small>
  
                                          </mat-form-field>
                                          
                                          <mat-form-field class="col-md-3" appearance="outline">
                                            <mat-label>Source</mat-label>
                                            <mat-select matNativeControl name="source" formControlName="sources">
                                              <!-- <mat-option  value="all">All</mat-option> -->
                                              <mat-option *ngFor="let item of sourceCodeList" [value]="item.code">{{item.title}}</mat-option>
                                            </mat-select>  
  
                                          </mat-form-field>   
                                          <mat-form-field class="col-md-3" appearance="outline">
                                              <mat-label>Sub Product</mat-label>
                                              <input matInput type="text"  name="supProduct" autocomplete="off" formControlName="subProduct">
  
                                            </mat-form-field> 
                                            <mat-form-field class="col-md-3" appearance="outline">
                                              <mat-label>Group Id</mat-label>
                                              <mat-select matNativeControl name="groupId" formControlName="group">
                                                <mat-option *ngFor="let group of groupList" [disabled]="action==='updatecredit'" [value]="group.code">{{group.name}}</mat-option>
  
                                              </mat-select>  
                                              <small *ngIf="creditRegFg.controls['group'].dirty && creditRegFg.controls['group'].invalid" class="warn">Please Select Group Id!</small>
  
                                            </mat-form-field> 
                                            <mat-form-field class="col-md-3" appearance="outline">
                                              <mat-label>Card Type</mat-label>
                                              <mat-select matNativeControl name="cardType" formControlName="cardType" (selectionChange)="changeCardType($event)">
                                                <mat-option *ngFor="let card of cardtypedata" [disabled]="action==='updatecredit'" [value]="card">{{card}}</mat-option>
  
                                              </mat-select>  
                                              <small *ngIf="creditRegFg.controls['cardType'].dirty && creditRegFg.controls['cardType'].invalid" class="warn">Please Select Card Type!</small>
  
                                            </mat-form-field>   
                                            <mat-form-field class="col-md-3" appearance="outline">
                                              <mat-label>Bank Name</mat-label>
                                              <mat-select matNativeControl name="bankName" formControlName="bankName">
                                                <mat-option *ngFor="let bank of bankdata" [disabled]="action==='updatecredit'" [value]="bank">{{bank}}</mat-option>
  
                                              </mat-select>  
                                              <small *ngIf="creditRegFg.controls['bankName'].dirty && creditRegFg.controls['bankName'].invalid" class="warn">Please Select Bank Name!</small>
  
                                            </mat-form-field>
                                            <mat-form-field class="col-md-3" appearance="outline">
                                              <mat-label>Card Holder Name</mat-label>
                                              <input matInput type="text" [readonly]="action==='updatecredit'"  name="cardHolder" autocomplete="off" formControlName="holderName">
                                              <small *ngIf="creditRegFg.controls['holderName'].dirty && creditRegFg.controls['holderName'].invalid" class="warn">Please Enter Card Holder Name!</small>
  
                                            </mat-form-field>   
                                            <mat-form-field *ngIf="action==='newcredit'" class="col-md-3" appearance="outline">
                                              <mat-label>Card Number</mat-label>
                                              <input matInput type="text"  name="cardNumber" autocomplete="off" formControlName="cardNumber" [minlength]="CardLenght" [maxlength]="CardLenght" (keypress)="onlyNumberKey($event)">
                                              <small *ngIf="creditRegFg.controls['cardNumber'].dirty && creditRegFg.controls['cardNumber'].invalid" class="warn">Please Enter Valid Card Number!</small>
  
                                            </mat-form-field> 
                                            <mat-form-field *ngIf="action==='updatecredit'" class="col-md-3" appearance="outline">
                                              <mat-label>Card Number</mat-label>
                                              <input matInput type="text"  name="cardNumber" autocomplete="off" readonly formControlName="cardNumber" [minlength]="CardLenght" [maxlength]="CardLenght" (keypress)="onlyNumberKey($event)">
                                              <small *ngIf="creditRegFg.controls['cardNumber'].dirty && creditRegFg.controls['cardNumber'].invalid" class="warn">Please Enter Valid Card Number!</small>
  
                                            </mat-form-field>  
                                            <mat-form-field *ngIf="action==='newcredit'" class="col-md-3" appearance="outline">
                                              <mat-label>Card CVV</mat-label>
                                              <input matInput type="text"  name="cvv" minlength="3" maxlength="6"  autocomplete="off" formControlName="cvv" (keypress)="onlyNumberKey($event)">
                                              <small *ngIf="creditRegFg.controls['cvv'].dirty && creditRegFg.controls['cvv'].invalid" class="warn">Please Enter Valid CVV Number!</small>
  
                                            </mat-form-field>     
                                            <mat-form-field class="col-md-3" appearance="outline">
                                              <mat-label>Expiry Date (MM/YYYY)</mat-label>
                                              <input matInput type="text"  name="expiryDate" autocomplete="off" formControlName="expiryDate" >
                                              <small *ngIf="creditRegFg.controls['expiryDate'].dirty && creditRegFg.controls['expiryDate'].invalid" class="warn">Please Enter Expiry Date!</small>
  
                                            </mat-form-field>  
                                            <mat-form-field class="col-md-3" appearance="outline">
                                              <mat-label>Accounts TAG</mat-label>
                                              <input matInput type="text" [readonly]="action==='updatecredit'"  name="accoutnTag" autocomplete="off" formControlName="accountsTag">
  
                                            </mat-form-field>   
                                            <mat-form-field class="col-md-3" appearance="outline">
                                              <mat-label>Min Root PassThrough Amt</mat-label>
                                              <input matInput type="text" [readonly]="action==='updatecredit'" name="Amt" autocomplete="off" formControlName="minimumPassthroughAmount" (keypress)="onlyNumberKey($event)">
                                              <small *ngIf="creditRegFg.controls['minimumPassthroughAmount'].dirty && creditRegFg.controls['minimumPassthroughAmount'].invalid" class="warn">Please Enter Min Root PassThrough Amt!</small>
  
                                            </mat-form-field> 
                                            <mat-form-field class="col-md-3 form-group required" appearance="outline">
                                              <mat-label for="addressCountry" >Country</mat-label>
                                              <input matInput type="text" [readonly]="action==='updatecredit'" [matAutocomplete]="autoCountry" [formControl]="addressCountryFormControl">
                                              <mat-autocomplete #autoCountry="matAutocomplete" [displayWith]="displayCountrySelectionFn">
                                                  <mat-option *ngFor="let option of countryFilteredOptions | async" [value]="option">
                                                      {{option.countryName}}
                                                  </mat-option>
                                              </mat-autocomplete>
                                              <mat-error>Please select correct country</mat-error>
                                          </mat-form-field>
                                          <mat-form-field class="col-md-3 form-group required" appearance="outline">
                                              <mat-label for="addressState">State</mat-label>
                                              <ng-container *ngIf="addressCountryFormControl?.value?.countryCode=='IN'" >
                                                  <input matInput type="text" [readonly]="action==='updatecredit'" [matAutocomplete]="autoState" [formControl]="addressStateFormControl">
                                                  <mat-autocomplete 
                                                              #autoState="matAutocomplete" [displayWith]="displayStateSelectionFn">
                                                      <mat-option *ngFor="let option of stateFilteredOptions | async" [value]="option">
                                                          {{option.stateName}}
                                                      </mat-option>
                                                  </mat-autocomplete>
                                              </ng-container>
                                              <ng-container *ngIf="addressCountryFormControl?.value?.countryCode !='IN'">
                                                  <input matInput type="text"  formControlName="stateText">
                                              </ng-container>
                                          </mat-form-field>
                                          <mat-form-field class="col-md-3 form-group required" appearance="outline">
                                              <mat-label for="addressCity">City</mat-label>
                                              <ng-container *ngIf="addressCountryFormControl?.value?.countryCode=='IN'" >
                                                  <input matInput type="text" [readonly]="action==='updatecredit'" [matAutocomplete]="autoCity" [formControl]="addressCityFormControl">
                                                  <mat-autocomplete 
                                                              #autoCity="matAutocomplete">
                                                      <mat-option *ngFor="let option of cityFilteredOptions | async" [value]="option">
                                                          {{option}}
                                                      </mat-option>
                                                  </mat-autocomplete>
                                              </ng-container>
                                              <ng-container *ngIf="addressCountryFormControl?.value?.countryCode !='IN'">
                                                  <input matInput type="text"  [formControl]="addressCityFormControl">
                                              </ng-container>
                                          </mat-form-field>
                                          <mat-form-field class="col-md-3 form-group required" appearance="outline">
                                              <mat-label for="addressPostalCode">Pincode</mat-label>
                                              <input matInput type="text" [formControl]="postalCodeFormCountol" (keypress)="onlyNumberKey($event)">
                                          </mat-form-field>
                                        
                                                    <mat-form-field class=" required col-md-3 form-group " appearance="outline">
                                                      <mat-label>Address</mat-label>
                                                      <input matInput [readonly]="action==='updatecredit'" type="text"   formControlName="street" name="street" autocomplete="off"  >
                                                    </mat-form-field>
                                                    <mat-form-field class=" required col-md-3 form-group " appearance="outline">
                                                      <mat-label>Travel Type</mat-label>
                                                      <mat-select  matNativeControl name="travelType" formControlName="travelType">
                                                        <mat-option   value="">--</mat-option>
                                                        <mat-option   value="D">Domestic</mat-option>
                                                        <mat-option   value="I">International</mat-option>

                                                      </mat-select> 
                                                    </mat-form-field>
                                                    <mat-form-field class=" required col-md-3 form-group " appearance="outline">
                                                      <mat-label>Branch</mat-label>
                                                      <mat-select multiple matNativeControl name="branch" formControlName="branch">
                                                        <mat-option *ngFor="let item of branchData" [value]="item.branchCode">{{item.city}}</mat-option>
          
                                                      </mat-select>  
                                                    </mat-form-field>
                                                    
                                                                      
                                          </form>
                                        </mat-tab>
                                        <mat-tab  label="Filters">
                                          <form class="row pt-3">
                                            <div class="col-md-12 row">
                                          <div class="col-md-2 pt-3 bold">Reseller</div>
                                            <mat-form-field class="col-md-5" appearance="outline" >
                                              <mat-label>Include/Exclude</mat-label>
                                              <mat-select [(ngModel)]="filter.resellerInclude" name="selection" >
                                                <mat-option value="I">Include</mat-option>
                                                <mat-option value="X">Exclude</mat-option>
                                              </mat-select>
                                              <!-- <input matInput type="text" name="includeCode" autocomplete="off" [(ngModel)]="filter.resellerInclude"  > -->
                                            </mat-form-field>
                                            <mat-form-field class="col-md-5" appearance="outline" >
                                              <mat-label>{{filter.resellerInclude==='I'?('Include'):'Exclude'}} (Reseller Code separated by :)</mat-label>
                                              <input matInput type="text" name="excludecode" autocomplete="off" [(ngModel)]="filter.resellerExclude"   >
                                            </mat-form-field>
                                          </div>
                                          <div class="col-md-12 row">
                                            <div class="col-md-2 pt-3 bold">Day of Month</div>
                                              <mat-form-field class="col-md-5" appearance="outline" >
                                                <mat-label>Include/Exclude</mat-label>
                                                <mat-select [(ngModel)]="filter.dayOfMonthInclude" name="selection" >
                                                  <mat-option value="I">Include</mat-option>
                                                  <mat-option value="X">Exclude</mat-option>
                                                </mat-select>
                                                <!-- <input matInput type="text" name="Includeday" autocomplete="off" [(ngModel)]="filter.dayOfMonthInclude"   > -->
                                              </mat-form-field>
                                              <mat-form-field class="col-md-5" appearance="outline" >
                                                <mat-label>{{filter.dayOfMonthInclude==='I'?('Include'):'Exclude'}} (Day of Month separated by :)</mat-label>
                                                <input matInput type="text" name="excludeday" autocomplete="off" [(ngModel)]="filter.dayOfMonthExclude" >
                                              </mat-form-field>
                                            </div>
                                            <div class="col-md-12 row">
                                              <div class="col-md-2 pt-3 bold" >Airport</div>
                                                <mat-form-field class="col-md-5" appearance="outline" >
                                                  <mat-label>Include/Exclude</mat-label>
                                                  <mat-select [(ngModel)]="filter.airportInclude" name="selection" >
                                                    <mat-option value="I">Include</mat-option>
                                                    <mat-option value="X">Exclude</mat-option>
                                                  </mat-select>
                                                  <!-- <input matInput type="text" name="include" autocomplete="off"  [(ngModel)]="filter.airportInclude"> -->
                                                </mat-form-field>
                                                <mat-form-field class="col-md-5" appearance="outline" >
                                                  <mat-label>{{filter.airportInclude==='I'?('Include'):'Exclude'}} (Airport Code separated by :)</mat-label>
                                                  <input matInput type="text" name="include" autocomplete="off" [(ngModel)]="filter.airportExclude" >
                                                </mat-form-field>
                                              </div>
                                        </form>
                                       </mat-tab>
                                        </mat-tab-group>
                                     



                                  </div>
                                  </div>
                                  </div>                                      
                            </div>
                            <div class="modal-footer">
                              <div class="col-md-12 row" *ngIf="action==='updatecredit'">
                              <div class="col-md-6">
                              <button type="button"  class="btn btn-danger" mdbRipple  (click)="DeleteCredit()">Delete</button>
                            </div>
                           <div class="col-md-6 d-flex justify-content-end">
                            <div class="col-md-12 row d-flex justify-content-end">
                            <div class="col-md-6 pt-2 d-flex justify-content-end">     
                              <mat-slide-toggle *ngIf="creditRegFg.value.status==='A'"  style="font-size: 14px;"  [(ngModel)]="creditStatus" (click)="updateCreditStatus('I')">Enabled</mat-slide-toggle>
                              <mat-slide-toggle *ngIf="creditRegFg.value.status==='I'"  style="font-size: 14px;"  [(ngModel)]="creditStatus" (click)="updateCreditStatus('A')">Enabled</mat-slide-toggle>

                            </div>
                          <div class="col-md-6  d-flex justify-content-end">
                            <button  class="btn btn-outline-success c-width-100px shadow "  (click)="updateCreditCard()" [disabled]="disabled()" style="margin-right: 4px;">Update</button>

                            <button  type="button" class="btn btn-outline-primary c-width-100px shadow" data-dismiss="modal" (click)="closePopup()">Close</button>
                        </div>
                            </div>
                            </div>
                              </div>
                              <button *ngIf="action==='newcredit'" class="btn btn-outline-success c-width-100px shadow "  (click)="AddCreditCard()" [disabled]="creditRegFg.invalid" >Save</button>
                              <button *ngIf="action==='newcredit'" type="button" class="btn btn-outline-primary c-width-100px shadow" data-dismiss="modal" (click)="closePopup()">Close</button>
                          
                            </div>
                             
                            </div>
                            </div>
                    </div>
                </div>
                